import React from 'react'
import {
  Redirect,
} from 'react-router-dom'
import PropTypes from 'prop-types'

import RouteWithSubRoutes from '../RouteWithSubRoutes'

const ProtectedRoute = (props) => (
  <RouteWithSubRoutes {...props} />
)

ProtectedRoute.defaultProps = {
  authUser: {},
  protected: true,
  path: '/',
}

ProtectedRoute.propTypes = {
  authUser: PropTypes.object,
  path: PropTypes.string,
  protected: PropTypes.bool,
}
export default ProtectedRoute
